import { h } from "preact";
import { useState, useEffect, } from "preact/hooks";

import {
	Box,
	Popover,
	Tooltip,
	Typography,
} from "@mui/material";

import { TogglePlusMinus } from "./TogglePlusMinus";
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

export default function FormNumericPlusMinus({ upperState, id, handleChange, helper }) {

	const [anchorEl, setAnchorEl] = useState(null);

	const handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};
	const value = upperState[id];
	const mnd = upperState[id + "_mnd"];
	const label = upperState[id + "_lbl"];
	const open = Boolean(anchorEl);
	return (
		<Box display="flex" justifyContent="space-between" alignItems="center" >
			<Box display="flex" justifyContent="flex-start" alignItems="center">
				<Box p={1}>
					<InfoIcon aria-haspopup="true"
						aria-owns={open ? 'mouse-over-popover' : undefined}
						onMouseEnter={handlePopoverOpen}
						onMouseLeave={handlePopoverClose}
						style="margin-top: 6px;"
						color={helper ? "" : "disabled"}
					/>
					<Popover
						id="mouse-over-popover"
						sx={{
							pointerEvents: 'none',
						}}
						open={open}
						anchorEl={anchorEl}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'left',
						}}
						onClose={handlePopoverClose}
						disableRestoreFocus
					>
						<Typography sx={{ p: 1 }}>{helper ? helper : <em>Pas encore d'aide, déso</em>}</Typography>
					</Popover>
				</Box>
				<Box p={1}>
					<Typography variant="body1">{label} {mnd ? "*" : null}</Typography>
				</Box>
				<Box p={1}>
					{upperState[id + "_fld"] ? <Tooltip title="Ce champ est obligatoire"><WarningIcon color="primary" /></Tooltip> : ""}
				</Box>
			</Box>

			<Box >
				<TogglePlusMinus name={id} value={value} setUpperState={handleChange} />
			</Box>

		</Box>
	);
}
